export class CustomersListLang {

    variables  = null;

    constructor(lang) {

        this.variables = {
            customers: lang.customer[0],        
            createNew: lang.customer[1],        
            code: lang.customer[2],        
            businessName: lang.customer[3],        
            address: lang.customer[4],        
            zipCode: lang.customer[5],        
            province: lang.customer[6],        
            taxCode: lang.customer[7],        
            fiscalCode: lang.customer[8],        
            phone: lang.customer[9],      
            email: lang.customer[10],      
            action: lang.customer[26],      
            customersList: lang.customer[79],      
            city: lang.customer[13],      
            website: lang.customer[11],      
            attachments: lang.customer[12],      
            selectColumns: lang.general[9],      
            selectAll: lang.general[10],      
            activeColumns: lang.general[11],      
            close: lang.general[17],      
            exportCSV: lang.general[13],      
            macroSector: lang.customer[92],      
            submit: lang.customer[53],      
            requiredField: lang.customer[57],      
            importCustomer: lang.customer[85],              
            clickhere: lang.customer[67],              
            todownloadcsvformat: lang.customer[68],              
        }

    }

    lang() {
        return this.variables;
    }

}

export class CustomersViewListLang {

    variables  = null;

    constructor(lang) {

        this.variables = {
            customers: lang.customer[0],        
            createNew: lang.customer[1],        
            code: lang.customer[2],        
            businessName: lang.customer[3],        
            address: lang.customer[4],        
            zipCode: lang.customer[5],        
            province: lang.customer[6],        
            taxCode: lang.customer[7],        
            fiscalCode: lang.customer[8],        
            phone: lang.customer[9],      
            email: lang.customer[10],      
            action: lang.customer[26],      
            customersList: lang.customer[79],      
            city: lang.customer[13],      
            website: lang.customer[11],      
            attachments: lang.customer[12],      
            selectColumns: lang.general[9],      
            selectAll: lang.general[10],      
            activeColumns: lang.general[11],      
            close: lang.general[17],      
            exportCSV: lang.general[13],      
            macroSector: lang.customer[92],      
            submit: lang.customer[53],      
            requiredField: lang.customer[57],      
            viewCustomer: lang.customer[87],      
            generalData: lang.customer[15],      
            operatingLocations: lang.customer[16],      
            employee: lang.customer[74],       
            notes: lang.customer[70],              
            erase: lang.customer[77],              
            modify: lang.customer[75],              
            name: lang.customer[20],              
            surname: lang.customer[21],              
            dob: lang.customer[22],              
            pob: lang.customer[23],              
            qualification: lang.customer[24],              
            business: lang.customer[25],              
            consultancy: lang.customer[17],              
            typeofContract: lang.customer[71],              
            meetingperYear: lang.customer[69],              
            startingDate: lang.customer[40],              
            contract: lang.customer[72],              
            amount: lang.customer[73],              
            academy: lang.customer[18],              
            coursecode: lang.customer[27],              
            catcode: lang.customer[28],              
            courseName: lang.customer[29],              
            courseCategory: lang.customer[30],              
            duration: lang.customer[31],              
            endDate: lang.customer[32],              
            startDate: lang.customer[33],              
            teacher: lang.customer[34],              
            status: lang.customer[35],              
            addEmployee: lang.customer[80],             
            exportPdf: lang.general[14],              
            exportExcel: lang.general[15],              
            print: lang.general[16],              
            todownloadtocsv: lang.customer[68],              
            project: lang.customer[19],              
            projectCode: lang.customer[36],              
            projectTitle: lang.customer[37],              
            customer: lang.customer[38],              
            responsible: lang.customer[39],              
            expectedDeliveryDate: lang.customer[41],              
            expectedHour: lang.customer[42],              
            closingDate: lang.customer[43],              
            completion: lang.customer[44],            
            paymentReference: lang.customer[45],              
            courseCode: lang.customer[27],              
            catCode: lang.customer[28],              
            export: lang.general[22],              
            durationHours: lang.customer[31],              
            importCustomer: lang.customer[85],              
            clickhere: lang.customer[67],                  
        }

    }

    lang() {
        return this.variables;
    }

}
